<template>
  <div id="detail" class="detail">
    <!-- <div class="back" @click="back"><img src="./img/backup.png" alt=""><span>返回上一页</span></div> -->
   
    <img style="width:100%" src="@/assets/serviceImg/yswz1.png">
    <div class="rich_text" style="text-indent: 0em;">全科医生每天早上8点-晚上8点医疗咨询，包括居家健康咨询、常见慢性病防治信息、健康促进信息或咨询、常规体检项目建议、体检报告异常结论建议、儿童合理常识及常见病处理、女性保健常见问题、家庭常见意外伤害处理建议、常见急性病症的处理建议。</div>
    <!-- <div class="rich_text" style="text-indent: 0em;margin-bottom: 3vw;">单价：1200元/人次。</div>
    <b style="color:#333333;font-weight: 500;font-size: 1rem;">注意事项：</b>
    <div class="rich_text"  style="text-indent: 0em;">
      1）服务包括主任和副主任级别的专家，乙方协助客户预约的门诊以最终医院端反馈的号源结果为准，本服务不支持指定医生姓名及级别、不支持指定就诊日期； 
    </div>
    <div class="rich_text"  style="text-indent: 0em;">
       2）预约科室除外口腔、产科、生殖、急诊、疫苗等预约；疑难科室服务时效可能延迟，客户如不接受可取消服务并退费；
    </div>
    <div class="rich_text"  style="text-indent: 0em;">
        3）客户如在乙方未向其发送启动通知之前（以乙方发送成功短信通知的时间为准）取消服务并及时通知乙方的，乙方不计算该次服务已使用，并直接退费；对于乙方发送启动通知后接到客户取消服务的，客户的取消行为无效，乙方视同客户已使用该次服务，并收取费用;
    </div>
    <div class="rich_text"  style="text-indent: 0em;">
      4）医院收取的挂号费及其他任何相关医疗费用，均由客户自行全部承担； 
    </div>
    <div class="rich_text"  style="text-indent: 0em;">
      5）乙方为客户提供服务过程中，如遇须客户配合提供各项资料或信息、接收手机验证码等情况，客户须向乙方予以配合，否则由此导致的服务延迟、服务失败均与乙方无关；
    </div>
    <div class="rich_text"  style="text-indent: 0em;">
     6）如疫情、医院临时停诊等不可抗力因素导致乙方无法落实预约或延长预约时效，不属于本服务违约； 
    </div>
     <div class="rich_text"  style="text-indent: 0em;">
     7）若遇到必须为客户垫付挂号费方可预约的号源，乙方将电话联系客户向其告知须为其垫付挂号费及金额，在客户同意由乙方垫付并在号源预约成功当天向乙方全额归还挂号费的前提下，乙方方可落实服务。若客户不同意返还乙方垫付挂号费，由此导致的服务失败与乙方无关。若客户未如期向乙方归还垫付费用，乙方有权中止其全部服务权益且不属于乙方违约，直至在服务有效期内客户向乙方归还全部欠款，乙方将在1个工作日内为其恢复全部服务权益； 
    </div>
    <div class="rich_text"  style="text-indent: 0em;">
     8）在号源预约成功后，无论客户能否如期就诊，均不属于本服务责任；若客户未能如期就诊并已经支付过挂号费，客户须根据相应医院政策自行办理退号及挂号费退费；
    </div>
    <div class="rich_text"  style="text-indent: 0em;">
     9）根据医院预约规则，预约过程中存在就诊当日反馈号源的情况，客户须接受。
    </div> -->
    <div class="add" style="width: 100%;height: 11vw;background: rgb(0, 187, 130);border-radius: 20px;text-align: center;line-height: 11vw;color: rgb(255, 255, 255);font-size: 4vw;display: flex;align-items: center;justify-content: center;" @click="actionCallHelp()">获取服务</div>
    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <span class="close" @click="showModal = false">&times;</span>
        <p style="margin-bottom: 7vw;">该项权益需开通以下服务权益</p>
        <div style="width:100%;height:40vw;position: relative;" @click="equity()">
          <img style="width: 100%;height: 100%;position: absolute;top: 2vw;" src="@/assets/img/qykbj.png" />
          <div>
             <h3 style="position: absolute;top: 17vw;left: 7vw;font-size: 5vw;">大救星-星健康权益卡</h3>
             <div style="position: absolute;top: 25vw;left: 7vw;color:#666666;font-size: 3.5vw;">多项健康权益尊享，为您健康守护</div>
             <div style="width: 18vw;height: 7vw;font-size: 3vw;line-height: 7vw;color: #F2D57A;text-align: center;background: rgb(74, 71, 64);border-radius: 16px;position: absolute;top: 17vw;right: 4vw;">了解更多</div>
          </div>
        </div>
      </div>
      
    </div>
  </div>


</template>
<script>
import Axios from 'axios'
export default {
  data () {
    return {
      attribute:'',
      src1:'',
      detailText: '',
      showModal:false,
      equityinfoType:false,
    };
  },
  created(){
    this.equityinfoType = localStorage.getItem('equityinfo');
  },
  mounted() {
    if(localStorage.getItem('oldAge') == 1) {
          document.getElementById("html").style.fontSize = "48px";
        }
  },
  beforeCreate() {
    document.title = "医学电话咨询"
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#F2F3F5");
  },
  methods: {
    actionCallHelp() {
      if(this.equityinfoType == false || this.equityinfoType == 'false') {
          this.showModal = true
        }else {
          this.$router.push({
            name: 'onClickRescue',
            query: {}
        });
        //   window.location.href =
        // 'appdjxhealth://actionCallHelp'
        }
    
    },
    equity() {
      this.$router.push({
              path: "/equity",
              query:{
              }
            });
    }
    // detail(){
    //   Axios({
    //     params:{
    //       id:this.$route.query.id
    //     },
    //     // util.config.api
    //     methods:'post',
    //     baseURL: 'https://api.dajiuxing.com.cn',
    //     url: '/1.0/news/news-info'
    //   }).then(res=>{
    //     console.log(res,'详情详情');
    //     this.detailText = res.data.obj;
    //     this.attribute = res.data.obj.attribute
    //     if(res.data.obj.attribute == 3) {
    //       this.src1 = res.data.obj.url
    //     }else {
    //       this.src1 = res.data.obj.pic
    //     }
       
    //   }).catch(error=>{
    //     console.log(error)
    //   })
    // },
    
  }
}
</script>
<style scoped >
.modal {
   
   position: fixed; 
   z-index: 1000000; 
   left: 0;
   top: 0;
   width: 100%; 
   height: 100%; 
   overflow: auto; 
   background-color: rgb(0,0,0); 
   background-color: rgba(0,0,0,0.4); 
 }
 .modal-content {
   background-color: #fefefe;
   padding: 8% 5%;
   border-radius: 12px 12px 0px 0px;
   position: absolute;
   bottom: 0;
   width: 100%;
   line-height: 0;
 }
 .close {
   color: #aaa;
   float: right;
   font-size: 28px;
   font-weight: bold;
 }
 .close:hover,
 .close:focus {
   color: black;
   text-decoration: none;
   cursor: pointer;
 }
  .title{
    line-height: 2rem;
    text-align: center;
    margin: 1rem 0;
    border-bottom: none;
    padding: 0;
  }
  h5{
    /* font-size: 1.04166vw; */
    font-weight: normal;
    margin-bottom: 1.04166vw;
  }   
  .rich_text {
    text-indent: 2em;
    width:100%;
    word-wrap: break-word;
  }
  .rich_text >>> img{
    width: 100%;
  }
  .back{
    cursor: pointer;
    margin-bottom: 1.04166vw;
  }
  img{
    width: 1.145833vw;
    /* height: 0.98958333vw; */
    vertical-align: middle;
    margin-right: .5vw;
    margin-bottom: 1rem;
  }
  .rich_text, .rich_text span, .rich_text p, .rich_text strong{
    font-size: 14px!important;
    color: #666!important;
    /* line-height: 1.5rem!important; */
  }
  .detail{
    padding: 1rem 1rem 2rem;
    width: 100%;
    height: auto;
    overflow-x: hidden;
  }
  .add {
    margin-top: 200px;
  }
</style>


// WEBPACK FOOTER //
// src/views/detailsH5/doctor.vue